// extracted by mini-css-extract-plugin
module.exports = {"socialList":"SocialIcons_socialList__lVq3p","socialItem":"SocialIcons_socialItem__iq-b0"};